export default __webpack_public_path__ + "static/media/ai-img2.1f6005ee.png";